export enum GetDiscordChannelType {
  Forum = "forum",
  Announcement = "announcement",
  Text = "text",
  All = "*",
}
